<!-- 
	This is the sign in page, it uses the dashboard layout in: 
	"./layouts/Default.vue" .
 -->

<template>
	<div>
		<a-row type="flex" :gutter="[24,24]" justify="space-around" align="middle">
			<!-- Sign In Form Column -->
			<a-col :span="24" :md="12" :lg="{span: 12, offset: 0}" :xl="{span: 6, offset: 2}" class="col-form">
				<h4 class="mb-30">浙江大虞建设有限公司</h4>
				<!-- <h5 class="font-regular text-muted">dayu</h5> -->

				<!-- Sign In Form -->
				<a-form
					id="components-form-demo-normal-login"
					:form="form"
					class="login-form"
					@submit="handleSubmit"
					:hideRequiredMark="true"
				>
					<a-form-item class="mb-10" label="账号" :colon="false">
						<a-input 
						v-decorator="[
						'username',
						{ rules: [{ required: true, message: '请输入你的账号!' }] },
						]" placeholder="账号" />
					</a-form-item>
					<a-form-item class="mb-5" label="密码" :colon="false">
						<a-input
						v-decorator="[
						'password',
						{ rules: [{ required: true, message: '请输入你的密码!' }] },
						]" type="password" placeholder="密码" />
					</a-form-item>
					<!-- <a-form-item class="mb-10">
    					<a-switch v-model="rememberMe" /> Remember Me
					</a-form-item> -->
					<a-form-item class="mt30">
						<a-button type="primary" block html-type="submit" class="login-form-button">
							登 录
						</a-button>
					</a-form-item>
				</a-form>
				<!-- / Sign In Form -->

				<!-- <p class="font-semibold text-muted">Don't have an account? <router-link to="/" class="font-bold text-dark">Sign Up</router-link></p> -->
			</a-col>
			<!-- / Sign In Form Column -->

			<!-- Sign In Image Column -->
			<a-col :span="24" :md="12" :lg="12" :xl="12" class="col-img">
				<div class="relative">
					<div>
						<img src="images/defaultbg.png" alt="" width="100%">
					</div>
					<div class="absolute w100 h100 flex items-center content-center red-circle" style="top: 0; left: 0;">
						<img src="images/mbs.png" alt="" width="400px" >
					</div>
				</div>
				<!-- <img src="images/img-signin.jpg" alt=""> -->
			</a-col>
			<!-- Sign In Image Column -->

		</a-row>
		
	</div>
</template>

<script>

	export default ({
		data() {
			return {
				// Binded model property for "Sign In Form" switch button for "Remember Me" .
				rememberMe: true,
			}
		},
		beforeCreate() {
			// Creates the form and adds to it component's "form" property.
			this.form = this.$form.createForm(this, { name: 'normal_login' });
		},
		methods: {
			// Handles input validation after submission.
			handleSubmit(e) {
				e.preventDefault();
				this.form.validateFields(async (err, values) => {
					if ( !err ) {
						// console.log('Received values of form: ', values) ;
						let check = await this.$api.checkLoginAccount(values.username, values.password)
						if(check.err == 0){
							let suc = await this.$api.login(values);
							if (suc) {
								this.$router.push("/")
							}
						}else if(check.err == 2){
							this.$message.warn(`账号不存在！`);
						}else if(check.err == 3){
							this.$message.warn(`密码错误！`);
						}
						// if (suc) {
						// 	this.$router.push("/")

						// 	// let rs = await this.$api.getIndex()
						// 	// if(rs.err == 0){
						// 	// 	if (rs.data.length > 0) {
						// 	// 		let link = rs.data[0].link
						// 	// 		// this.$router.push(`/purchase/materials?permissionID=${this.user_permission_id}`)
						// 	// 		this.$router.push(`${link}`)
						// 	// 	} else {
						// 	// 		this.$router.push("/")
						// 	// 	}
								
						// 	// }
						// }
					}
				});
			},
		},
	})

</script>

<style lang="scss">
	body {
		background-color: #ffffff;
	}
	@keyframes updown {
		0% {
			top: 0px;
		}
		50% {
			top: -8px;
		}
		100% {
			top: 0px;
		}
	}
	.red-circle {
		// animation: updown 5.0s infinite;
	}
</style>